var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLongArrow = function SvgLongArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.938 30.66-2.21 2.21L8 20.142l2.21-2.21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.728 32.87-2.273-2.273 14.142-14.142 2.273 2.273z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.142 1 .357 30.1-1.771 1.77-1.516-1.515-.314-27.112z"
  })));
};
export { SvgLongArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMWVtIiBoZWlnaHQ9IjFlbSIgdmlld0JveD0iMCAwIDQyIDQyIiBmaWxsPSJjdXJyZW50Q29sb3IiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yMi45Mzc2IDMwLjY2MDNMMjAuNzI3OSAzMi44N0w3Ljk5OTk1IDIwLjE0MjFMMTAuMjA5NyAxNy45MzI0TDIyLjkzNzYgMzAuNjYwM1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yMC43Mjc5IDMyLjg3TDE4LjQ1NSAzMC41OTcyTDMyLjU5NzEgMTYuNDU1MUwzNC44NyAxOC43Mjc5TDIwLjcyNzkgMzIuODdaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjIuMTQxOSAwLjk5OTU1OEwyMi40OTg1IDMxLjA5OTRMMjAuNzI3OSAzMi44N0wxOS4yMTIzIDMxLjM1NDVMMTguODk4MSA0LjI0MzMxTDIyLjE0MTkgMC45OTk1NThaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";